
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#2868C8"}},[_c('path',{attrs:{"opacity":".4","d":"M47 40.5c-.01 1.73-1.364 3.375-3.368 3.375H3.365C1.363 43.875.01 42.23 0 40.5a3.305 3.305 0 01.903-2.29c2.027-2.19 5.82-5.484 5.82-16.273 0-8.194 5.715-14.755 13.422-16.364V3.375c0-.895.353-1.754.983-2.386a3.348 3.348 0 014.747 0c.63.632.984 1.49.984 2.386v2.198c7.7 1.61 13.416 8.17 13.416 16.364 0 10.79 3.792 14.084 5.82 16.273.584.617.908 1.438.905 2.29z"}}),_c('path',{attrs:{"d":"M16.786 47.25h13.428c0 1.79-.707 3.507-1.966 4.773A6.696 6.696 0 0123.5 54a6.697 6.697 0 01-4.748-1.977 6.768 6.768 0 01-1.966-4.773z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h47v54H0z"}})])])])
          )
        }
      }
    